import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "customer-display-page" }
const _hoisted_2 = { class: "customer-display-header" }
const _hoisted_3 = { class: "brand-wrap" }
const _hoisted_4 = { class: "brand-mark" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "brand-copy" }
const _hoisted_8 = { class: "brand-eyebrow" }
const _hoisted_9 = { class: "header-meta" }
const _hoisted_10 = { class: "meta-card" }
const _hoisted_11 = { class: "meta-card status-card" }
const _hoisted_12 = { class: "customer-display-main" }
const _hoisted_13 = { class: "transaction-stage" }
const _hoisted_14 = { class: "receipt-shell" }
const _hoisted_15 = { class: "receipt-head" }
const _hoisted_16 = { class: "section-kicker" }
const _hoisted_17 = { class: "receipt-status" }
const _hoisted_18 = { class: "receipt-customer" }
const _hoisted_19 = { class: "receipt-customer-card" }
const _hoisted_20 = { class: "receipt-customer-card" }
const _hoisted_21 = {
  key: 0,
  class: "receipt-customer-card"
}
const _hoisted_22 = { class: "receipt-items" }
const _hoisted_23 = { class: "receipt-items-head" }
const _hoisted_24 = { class: "receipt-row receipt-row-head" }
const _hoisted_25 = { class: "receipt-product" }
const _hoisted_26 = {
  key: 0,
  class: "receipt-variant"
}
const _hoisted_27 = {
  key: 1,
  class: "receipt-promo"
}
const _hoisted_28 = { class: "receipt-totals" }
const _hoisted_29 = { class: "total-row" }
const _hoisted_30 = {
  key: 0,
  class: "total-row is-negative"
}
const _hoisted_31 = {
  key: 1,
  class: "total-row is-negative"
}
const _hoisted_32 = {
  key: 2,
  class: "total-row is-negative"
}
const _hoisted_33 = {
  key: 3,
  class: "total-row"
}
const _hoisted_34 = {
  key: 4,
  class: "total-row"
}
const _hoisted_35 = { class: "total-row is-grand" }
const _hoisted_36 = {
  key: 5,
  class: "total-row"
}
const _hoisted_37 = {
  key: 6,
  class: "total-row"
}
const _hoisted_38 = {
  key: 1,
  class: "receipt-empty-state"
}
const _hoisted_39 = { class: "receipt-empty-grid" }
const _hoisted_40 = { class: "receipt-customer-card" }
const _hoisted_41 = { class: "receipt-customer-card" }
const _hoisted_42 = { class: "receipt-totals is-empty" }
const _hoisted_43 = { class: "total-row" }
const _hoisted_44 = { class: "total-row" }
const _hoisted_45 = { class: "total-row is-grand" }
const _hoisted_46 = { class: "experience-shell" }
const _hoisted_47 = {
  key: 0,
  class: "payment-shell"
}
const _hoisted_48 = { class: "section-kicker" }
const _hoisted_49 = { class: "qr-card" }
const _hoisted_50 = { class: "payment-amount" }
const _hoisted_51 = { class: "payment-note" }
const _hoisted_52 = {
  key: 1,
  class: "promo-shell"
}
const _hoisted_53 = {
  key: 0,
  class: "promo-live-wrap"
}
const _hoisted_54 = { class: "section-kicker" }
const _hoisted_55 = { class: "promo-banner promo-banner-live" }
const _hoisted_56 = { class: "promo-live-meta" }
const _hoisted_57 = { class: "promo-live-card" }
const _hoisted_58 = { class: "promo-live-card" }
const _hoisted_59 = { class: "promo-live-card" }
const _hoisted_60 = {
  key: 1,
  class: "promo-image-wrap"
}
const _hoisted_61 = { class: "promo-image-stage" }
const _hoisted_62 = ["src", "alt"]
const _hoisted_63 = {
  key: 1,
  class: "promo-image-fallback"
}
const _hoisted_64 = { class: "promo-caption-panel" }
const _hoisted_65 = { class: "section-kicker" }
const _hoisted_66 = { class: "promo-list" }
const _hoisted_67 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRCodeGenerator = _resolveComponent("QRCodeGenerator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "customer-display-orb orb-one" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "customer-display-orb orb-two" }, null, -1)),
    _createElementVNode("div", {
      ref: "displayViewport",
      class: "customer-display-viewport",
      style: _normalizeStyle({ '--display-scale': _ctx.displayScale.toString() })
    }, [
      _createElementVNode("header", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.brandLogo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.brandLogo,
                  alt: `${_ctx.displayState.branding.site_name} logo`
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.brandInitial), 1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("pos.customer_screen")), 1),
            _createElementVNode("h1", null, _toDisplayString(_ctx.displayState.branding.site_name), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.heroMessage), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.now_serving")), 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.liveTime), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.liveDate), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.screen_mode")), 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.statusLabel), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.statusCaption), 1)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_12, [
        _createElementVNode("section", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.invoiceKicker), 1),
                _createElementVNode("h2", null, _toDisplayString(_ctx.hasActiveInvoice ? _ctx.activeReference : _ctx.$t("pos.waiting_for_next_invoice")), 1)
              ]),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.invoiceStatus), 1)
            ]),
            (_ctx.hasActiveInvoice)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.customer")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.activeCustomerName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.counter")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.activeWarehouseName), 1)
                    ]),
                    (_ctx.isCompletedMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.sale_time")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.displayState.bill?.date || "-"), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.items")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.item_count_total", { count: _ctx.activeItemsCount })), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.product")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.qty")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.total")), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItems, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "receipt-row"
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.formatMoney(item.unit_price)) + " each", 1),
                          (_ctx.getLineSelectionLabel(item))
                            ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.getLineSelectionLabel(item)), 1))
                            : _createCommentVNode("", true),
                          (item.discount_amount > 0)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.getLinePromotionLabel(item)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", null, _toDisplayString(item.quantity), 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(item.total)), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.subtotal")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeBaseSubtotal)), 1)
                    ]),
                    (_ctx.activeItemDiscountTotal > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.item_promotions")), 1),
                          _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.formatMoney(_ctx.activeItemDiscountTotal)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeDiscount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.activePromotion ? _ctx.activePromotion.name : _ctx.$t("pos.order_discount")), 1),
                          _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.formatMoney(_ctx.activeDiscount)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeCouponDiscount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.coupon")), 1),
                          _createElementVNode("strong", null, "-" + _toDisplayString(_ctx.formatMoney(_ctx.activeCouponDiscount)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeTax > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.tax")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeTax)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.activeShipping > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.shipping")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeShipping)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.total_due")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeGrandTotal)), 1)
                    ]),
                    (_ctx.isCompletedMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.amount_received")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeAmountReceived)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isCompletedMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.activeDue > 0 ? _ctx.$t("pos.balance_due") : _ctx.$t("pos.change_return")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeDue > 0 ? _ctx.activeDue : _ctx.activeChange)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("pos.customer_display_empty_message")), 1),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.status")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t("pos.available_for_next_invoice")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.counter")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.displayState.branding.site_name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.subtotal")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.promotions")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(0)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.total_due")), 1),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(0)), 1)
                    ])
                  ])
                ]))
          ]),
          _createElementVNode("aside", _hoisted_46, [
            (_ctx.showQrPanel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t("pos.scan_to_pay")), 1),
                  _createElementVNode("h3", null, _toDisplayString(_ctx.activePaymentMethodLabel), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.heroMessage), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_QRCodeGenerator, {
                      value: _ctx.qrValue,
                      size: _ctx.qrCodeSize
                    }, null, 8, ["value", "size"])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.amount")), 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activeGrandTotal)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.displayState.branding.note_to_customer), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  (_ctx.activePromotion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("pos.live_promotion")), 1),
                        _createElementVNode("h3", null, _toDisplayString(_ctx.activePromotion.name), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.activePromotionDescription), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.activePromotionValueLabel), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.activePromotionTag), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("article", _hoisted_57, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.applies_to")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.activePromotion.customer_name || _ctx.$t("pos.all_walk_in_and_selected_customers")), 1)
                          ]),
                          _createElementVNode("article", _hoisted_58, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.schedule")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.activePromotionSchedule), 1)
                          ]),
                          _createElementVNode("article", _hoisted_59, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("pos.estimated_saving")), 1),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatMoney(_ctx.activePromotion.applied_amount || 0)), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          (_ctx.activePosterImage)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.activePosterImage,
                                alt: _ctx.activePosterCaption
                              }, null, 8, _hoisted_62))
                            : (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.displayState.branding.site_name), 1)),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("pos.house_promotions")), 1),
                            _createElementVNode("h3", null, _toDisplayString(_ctx.activePosterCaption), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posterCards, (poster) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: `${poster.image || _ctx.posterCaption(poster)}-aside`,
                              class: "promo-list-card"
                            }, [
                              (_ctx.posterImageUrl(poster))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.posterImageUrl(poster),
                                    alt: _ctx.posterCaption(poster)
                                  }, null, 8, _hoisted_67))
                                : _createCommentVNode("", true),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.posterCaption(poster)), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                ]))
          ])
        ])
      ])
    ], 4)
  ]))
}